import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/india.geojson";

const REGIONS = [
    { code: "Andaman and Nicobar Islands", name: "Andaman and Nicobar Islands" },
    { code: "Andhra Pradesh", name: "Andhra Pradesh" },
    { code: "Assam", name: "Assam" },
    { code: "Bihar", name: "Bihar" },
    { code: "Chandigarh", name: "Chandigarh" },
    { code: "Chhattisgarh", name: "Chhattisgarh" },
    { code: "Dadra and Nagar Haveli", name: "Dadra and Nagar Haveli" },
    { code: "Daman and Diu", name: "Daman and Diu" },
    { code: "Delhi", name: "Delhi" },
    { code: "Goa", name: "Goa" },
    { code: "Gujarat", name: "Gujarat" },
    { code: "Haryana", name: "Haryana" },
    { code: "Himachal Pradesh", name: "Himachal Pradesh" },
    { code: "Jammu and Kashmir", name: "Jammu and Kashmir" },
    { code: "Jharkhand", name: "Jharkhand" },
    { code: "Karnataka", name: "Karnataka" },
    { code: "Kerala", name: "Kerala" },
    { code: "Lakshadweep", name: "Lakshadweep" },
    { code: "Madhya Pradesh", name: "Madhya Pradesh" },
    { code: "Maharashtra", name: "Maharashtra" },
    { code: "Manipur", name: "Manipur" },
    { code: "Meghalaya", name: "Meghalaya" },
    { code: "Mizoram", name: "Mizoram" },
    { code: "Nagaland", name: "Nagaland" },
    { code: "Odisha", name: "Odisha" },
    { code: "Pondicherry", name: "Pondicherry" },
    { code: "Punjab", name: "Punjab" },
    { code: "Rajasthan", name: "Rajasthan" },
    { code: "Sikkim", name: "Sikkim" },
    { code: "Tamil Nadu", name: "Tamil Nadu" },
    { code: "Telangana", name: "Telangana" },
    { code: "Tripura", name: "Tripura" },
    { code: "Uttar Pradesh", name: "Uttar Pradesh" },
    { code: "Uttarakhand", name: "Uttarakhand" },
    { code: "West Bengal", name: "West Bengal" },
];

const REGION_CODES = REGIONS.map(r => r.code);

const IndiaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1100, center: [80, 22] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="india"
            analyticsLocationType="india"
            trackingLabel="India Map"
            storageKey="india_map"
            title="🇮🇳 India Travel Map"
            subtitle="Click on Indian states and union territories you've visited. Or use the checklist below!"
            items={REGIONS.map(r => ({ id: r.code, name: r.name }))}
            noun="States"
            unitLabel="states"
            captionUnit="Indian states"
            share={{
                region: 'India',
                fileName: 'visited-india-map.png',
                trackId: 'india'
            }}
            renderMap={renderMap}
        />
    );
};

export default IndiaMapSection;
